import { useMutation, useQuery } from '@tanstack/react-query';
import {
  type Company,
  type LoginParams,
  type LoginResponse,
  type NewRegisterParams,
  type NewRegisterResponse,
} from './interfaces';
import { edupassClient } from '@/data/@clients';
import { setAuthToken } from '@/utils/auth-token';

export const useGetCompanyByCode = (code: string | null) => {
  return useQuery({
    queryKey: ['company-by-code', code],
    queryFn: async () => {
      if (!code) return null;

      const { data } = await edupassClient.get<Company>(
        '/get_company_by_code',
        { params: { code } }
      );
      return data;
    },
    enabled: !!code,
    retry: false,
  });
};

export const useNewRegister = () => {
  return useMutation({
    mutationFn: async (params: NewRegisterParams) => {
      const { data } = await edupassClient.post<NewRegisterResponse>(
        '/new_register',
        params
      );

      if (data) setAuthToken(data.data);

      return data?.data;
    },
  });
};

export const useLogin = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (params: LoginParams) => {
      const { data } = await edupassClient.post<LoginResponse>(
        '/login',
        params
      );

      if (data) setAuthToken(data.token);

      return data;
    },
  });

  return {
    login: mutate,
    isPending,
  };
};
